module.exports = __webpack_public_path__ + "static/media/SCR007.49de05b8.mp3";